import { ThemeTypographyInterface } from './theme-interface';

export const BaSeTypography: ThemeTypographyInterface = {
  fontFamily:
    'Figtree, "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
  fontSizeBase: '16px',
  lineHeightBase: '16px',
};
